export default __webpack_public_path__ + "static/media/17.fc4a476e.png";